import { render, staticRenderFns } from "./EditKeyDialog.vue?vue&type=template&id=56c0f095&scoped=true&"
import script from "./EditKeyDialog.vue?vue&type=script&lang=js&"
export * from "./EditKeyDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditKeyDialog.vue?vue&type=style&index=0&id=56c0f095&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0f095",
  null
  
)

export default component.exports